import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 4px 4px rgba(6, 0, 173, 0.15)',
    margin: '10px auto',
    backgroundColor: '#ffff',
    cursor: 'pointer',

    [theme.breakpoints.up('lg')]: {
      height: '100%',
      width: '93%',
      minWidth: 277,
      maxWidth: 312.5
    },
    '&.createCard': {
      height: 267
    }
  },
  container: {
    textDecoration: 'none',
    display: 'contents'
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '70%'
  },
  headerContainer: {
    display: 'flex',
    backgroundColor: theme.palette.primary.main,
    color: '#ffff',
    justifyContent: 'space-between',
    height: 55,
    alignItems: 'center',
    padding: theme.spacing(0, 2)
  },
  headerContainerResult: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main
  },
  bodyContainer: {
    padding: theme.spacing(2, 1)
  },

  featureImageContainer: {
    width: '100%',
    height: '39vw',
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      maxHeight: 152,
      height: '9.5vw',
      minHeight: 135
    }
  },
  featureImage: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  actionButtonContainer: {
    flexShrink: 0,
    backgroundColor: theme.palette.primary.main,
    color: '#ffff',
    width: '100%',
    display: 'flex',
    height: 50,
    padding: theme.spacing(0, 1),

    '&.center': {
      justifyContent: 'center'
    }
  },
  actionButton: {
    color: '#ffff',
    '& em': {
      fontSize: '0.75em',
      fontWeight: 200,
      fontStyle: 'normal',
      fontFamily: theme.typography.fontFamily,
      marginLeft: theme.spacing()
    },
    '&:disabled': {
      color: '#ffff'
    }
  },
  actionSocialBarButton: {
    flexGrow: 1
  },
  locationContainer: {
    display: 'flex',
    alignItems: 'center',
    maxHeight: '50%',
    '& p': {
      color: 'rgba(105, 105, 105, 1)',
      fontSize: '0.8rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical'
    }
  },
  date: {
    fontWeight: 500,
    textTransform: 'uppercase'
  },
  sportContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1, 0)
  },
  sport: {
    fontSize: '0.8rem',
    fontWeight: 500,
    textTransform: 'uppercase'
  },
  liveContainer: {
    backgroundColor: '#ffff',
    borderRadius: 999
  },
  liveSport: {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'flex-end',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.2, 0.9),
    borderRadius: 999,
    backgroundColor: 'rgba(232, 57, 70, 0.12)',
    border: '1px solid rgba(232, 57, 70, 0.45)',
    color: '#E83946',
    fontWeight: 700,
    fontSize: '1rem',
    letterSpacing: '0.04em',
    '&::before': {
      content: '""',
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: '#E83946',
      filter: 'drop-shadow(0 0 3px rgba(232, 57, 70, 0.45))',
      animation: '$livePulse 1.8s ease-in-out infinite'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.1rem'
    }
  },
  '@keyframes livePulse': {
    '0%': {
      opacity: 0.95,
      transform: 'scale(0.95)'
    },
    '50%': {
      opacity: 0.55,
      transform: 'scale(1.08)'
    },
    '100%': {
      opacity: 0.95,
      transform: 'scale(0.95)'
    }
  },
  nameEventContainer: {
    padding: '12px 0px',
    height: 60,
    boxShadow: '0px 4px 4px rgba(6, 0, 173, 0.15)',
    display: 'flex',
    alignItems: 'center'
  },
  nameEvent: {
    fontWeight: 500,
    fontSize: '.9rem',
    padding: theme.spacing(0, 2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap',
    WebkitBoxOrient: 'vertical'
  },
  link: {
    color: theme.palette.primary.main,
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  messageContainer: {
    padding: theme.spacing(1),
    height: 65,
    display: 'flex',
    alignItems: 'center',
    '& h5': {
      fontWeight: 600
    }
  },
  description: {
    fontSize: '.9rem',
    margin: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',

    '& strong': {
      color: theme.palette.primary.main,
      fontWeight: 400
    }
  },
  loadResultContainer: {
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',
    height: 33,
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontWeight: 600
    },
    backgroundColor: theme.utils.rgba(theme.palette.secondary.main, 0.7),
    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    },
    color: theme.palette.primary.main
  },
  shareButton: {
    color: theme.palette.primary.contrastText,
    borderRadius: 15,
    '& svg': {
      color: theme.palette.primary.contrastText
    },

    '&.alt': {
      marginBottom: theme.spacing(),
      borderRadius: 70,
      '& svg': {
        color: `${theme.palette.primary.main} !important`
      },
      color: `${theme.palette.primary.main} !important`
    }
  },
  textContainer: {
    height: 115,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 2)
  },
  organizationContainer: {
    padding: theme.spacing(1, 0)
  },
  organization: {
    fontSize: '0.9rem',
    color: 'rgba(105, 105, 105, 1)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',

    '& span': {
      color: theme.palette.primary.main
    },

    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',

      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },
  endContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  linkInscription: {
    textDecoration: 'none',
    backgroundColor: theme.palette.secondary.main,
    width: 150,
    minWidth: 150,
    marginRight: theme.spacing(2),
    marginTop: 2,
    padding: 0,
    textAlign: 'center',
    borderRadius: 10,
    height: 20,
    display: 'flex',
    alignItems: 'center',

    '&.disabled': {
      backgroundColor: theme.palette.alt.light,

      '& span': {
        color: theme.palette.primary.contrastText
      }
    },

    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    },

    '& span': {
      color: theme.palette.primary.main,
      fontWeight: 500
    }
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    height: 25,
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  },
  suspendedBanner: {
    backgroundColor: theme.palette.suspended.main
  },
  cancelledBanner: {
    backgroundColor: theme.palette.cancelled.main
  },
  noQuotaBanner: {
    backgroundColor: theme.palette.primary.contrastText
  },

  bannerTitle: {
    fontSize: '.75rem',
    fontWeight: 700,
    color: theme.palette.primary.contrastText
  },
  altBannerTitle: {
    fontSize: '.75rem',
    fontWeight: 700,
    color: theme.palette.primary.main
  },
  running: {
    '&.size-2': {
      backgroundPositionX: '27%'
    },
    '&.size-3': {
      backgroundPositionX: '32%'
    }
  },
  'mountain-bike': {
    '&.size-2': {
      backgroundPositionX: '46%'
    },
    '&.size-3': {
      backgroundPositionX: '60%'
    }
  },
  natacion: {
    '&.size-2': {
      backgroundPositionX: '55%'
    },
    '&.size-3': {
      backgroundPositionX: '70%'
    }
  },
  biking: {
    '&.size-2': {
      backgroundPositionX: '1%'
    },
    '&.size-3': {
      backgroundPositionX: '15%'
    }
  },
  fbi: {
    '&.size-2': {
      backgroundPositionX: '52%'
    }
  },
  kayak: {
    '&.size-2': {
      backgroundPositionX: '38%'
    },
    '&.size-3': {
      backgroundPositionX: '30%'
    }
  },
  automovilismo: {
    '&.size-2': {
      backgroundPositionX: '42%'
    },
    '&.size-3': {
      backgroundPositionX: '26%'
    }
  },
  motocross: {
    '&.size-2': {
      backgroundPositionX: '97%'
    },
    '&.size-3': {
      backgroundPositionX: '91%'
    }
  },
  trekking: {
    '&.size-2': {
      backgroundPositionX: '29%'
    },
    '&.size-3': {
      backgroundPositionX: '26%'
    }
  },
  ocr: {
    '&.size-3': {
      backgroundPositionX: '60%'
    }
  },
  championshipContent: {
    alignSelf: 'center'
  },
  championshipButton: {
    color: theme.palette.primary.contrastText,

    '& span': {
      fontSize: '.875rem',
      fontWeight: 500
    }
  }
}))
